import React from 'react';
import { useResponseTemplateSetState } from '../../model';

const OpenModalBtn = ({ render }) => {
  const { open } = useResponseTemplateSetState();

  return render({ onClick: (item) => open(item) });
};

export default OpenModalBtn;
